/**
 * Accordion
 *
 * @since   1.1.1
 * @package hbs
 */
(function($) {
    var $faqs = $('#faqs');
    $(document).ready(function() {
        if ( $faqs ) {
            // Catch clicks on accordion titles
            $faqs.find('.faq-title').on('click', function(){
                _accordionToggleContent( $(this) );
            });
        }

        // Toggle visibility of the content area
        function _accordionToggleContent ( $title ) {
            $title.toggleClass('-active');
        }
    }); // document.ready
})(jQuery);
